import { Fragment } from "react";
import {
    ViewListingDescriptionPopupWrapper,
    ViewListingDescriptionPopupTitle,
    ViewListingDescriptionPopupText,
} from "../viewListingStyling";
import GlobalPopupContainerCenter from "../../../components/globalPopup/GlobalPopupContainerCenter";
import useClickOutside from "../../../hook/useClickOutside";

interface ViewListingDescriptionPopupProps {
    description: string;
    toggleSelected: () => void;
    selected: boolean;
}

export default function ViewListingDescriptionPopup({ description, toggleSelected, selected }: ViewListingDescriptionPopupProps) {
    const wrapperRef = useClickOutside(selected, toggleSelected);

    const formatTextWithLineBreaks = (text: string) => {
        return text.split("\n").map((line, index) => (
            <Fragment key={index}>
                {line}
                <br />
            </Fragment>
        ));
    };

    if (!selected) return null;

    return (
        <GlobalPopupContainerCenter 
            ref={wrapperRef} 
            backBtnType={"Close"} 
            closePopup={toggleSelected} 
            style={{ 
                height: "calc(100vh - 80px)",
                maxHeight: "800px"
            }}
            desktopWidth="704px"
            noContinueBtn
        >
            <ViewListingDescriptionPopupWrapper style={{ 
                height: "100%",
                padding: "40px 0",
                overflowY: "auto"
            }}>
                <ViewListingDescriptionPopupTitle>About your place</ViewListingDescriptionPopupTitle>
                <ViewListingDescriptionPopupText>
                    {formatTextWithLineBreaks(description)}
                </ViewListingDescriptionPopupText>
            </ViewListingDescriptionPopupWrapper>
        </GlobalPopupContainerCenter>
    );
} 